const TO_LETTER = { 0: "O", 1: "I", 2: "Z", 4: "A", 5: "S", 6: "G", 7: "T", 8: "B" };
const TO_DIGIT = { O: "0", Q: "0", D: "0", U: "0", I: "1", L: "1", J: "1", Z: "2", A: "4", S: "5", G: "6", T: "7", B: "8" };
const isL = (c) => /[A-Z]/.test(c);
const isD = (c) => /[0-9]/.test(c);

// Ajusta 7 caracteres ao formato ABC1234 ou ABC1D23; devolve {plate, fixes} ou null
function coerce(w) {
  let fixes = 0;
  const out = [];
  for (let i = 0; i < 7; i++) {
    const c = w[i];
    if (i < 3) {
      if (isL(c)) { out.push(c); } else if (TO_LETTER[c]) { out.push(TO_LETTER[c]); fixes++; } else { return null; }
    } else if (i === 4) {
      out.push(c);
    } else if (isD(c)) { out.push(c); } else if (TO_DIGIT[c]) { out.push(TO_DIGIT[c]); fixes++; } else { return null; }
  }
  return { plate: out.join(""), fixes };
}

export function extractPlate(text) {
  const lines = String(text || "").toUpperCase().split(/\n+/).map((l) => l.replace(/[^A-Z0-9]/g, "")).filter((l) => l.length >= 7);
  const all = String(text || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  let best = null;
  for (const src of [...lines, all]) {
    for (let i = 0; i + 7 <= src.length; i++) {
      const r = coerce(src.slice(i, i + 7));
      if (r && (!best || r.fixes < best.fixes)) { best = r; }
    }
  }
  return best && best.fixes <= 3 ? best.plate : null;
}

function toCanvas(img, mode) {
  const scale = Math.min(1, 1600 / Math.max(img.width, img.height));
  const w = Math.round(img.width * scale), h = Math.round(img.height * scale);
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  const ctx = c.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  const d = ctx.getImageData(0, 0, w, h);
  const px = d.data;
  let sum = 0;
  for (let i = 0; i < px.length; i += 4) { const g = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2]; px[i] = px[i + 1] = px[i + 2] = g; sum += g; }
  if (mode === "bin") {
    const avg = sum / (px.length / 4);
    for (let i = 0; i < px.length; i += 4) { const v = px[i] > avg * 0.85 ? 255 : 0; px[i] = px[i + 1] = px[i + 2] = v; }
  }
  ctx.putImageData(d, 0, 0);
  return c;
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { resolve(img); setTimeout(() => URL.revokeObjectURL(url), 1000); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("img")); };
    img.src = url;
  });
}

let workerP = null;
async function getWorker() {
  if (!workerP) {
    workerP = (async () => {
      const { createWorker } = await import("tesseract.js");
      const w = await createWorker("eng");
      await w.setParameters({ tessedit_char_whitelist: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-" });
      return w;
    })().catch((e) => { workerP = null; throw e; });
  }
  return workerP;
}

export async function readPlateFromFile(file) {
  const img = await loadImage(file);
  const w = await getWorker();
  for (const [mode, psm] of [["gray", "6"], ["gray", "7"], ["bin", "6"], ["bin", "11"]]) {
    await w.setParameters({ tessedit_pageseg_mode: psm });
    const { data } = await w.recognize(toCanvas(img, mode));
    const p = extractPlate(data.text);
    if (p) { return p; }
  }
  return null;
}
